<div class="flex flex-col w-full h-full -m-6">

  <!-- Header -->
  <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">
      {{ 'services.dialog.modifyTaskType.title' | transloco }} "{{ taskType.name }}"
    </div>
    <div class="flex justify-end items-end">
      <button mat-stroked-button (click)="modifyType()" class="mr-5">
        {{ 'saveChanges' | transloco }}
      </button>
      <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
        <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto p-6 sm:p-8" fuseScrollbar>
    @if (dtypeForm) {
      <dtype-component-list [dtypeForm]="dtypeForm" [isUpdate]="true">
      </dtype-component-list>
    }
  </div>

</div>